<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading">

            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="">
                        <div class="x_panel">
                            <h2 class="float-left">Component List</h2>
                            <ul class="nav navbar-right panel_toolbox align-right">
                                <li v-if="isPermissionExist(PERMISSIONS.COMPONENT_CREATE)">
                                    <button type="button" class="btn btn-info btn-sm" @click="create">Add New <i class="fa fa-plus"></i></button>
                                </li>
                              <li  v-if="isPermissionExist(PERMISSIONS.COMPONENT_PRINT)">
                                <button
                                  @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                                  <i class="fa fa-print" v-if="!isPrinting"></i>
                                  <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                                  {{ isPrinting ? 'Printing...' : 'Print' }}
                                </button>
                              </li>
                              <li  v-if="isPermissionExist(PERMISSIONS.COMPONENT_PRINT)">
                                <vue-excel-xlsx
                                  ref="excel"
                                  :data="excelData"
                                  :columns="excelHeader"
                                  :file-name="'Component List'"
                                  :file-type="'xlsx'"
                                  :sheet-name="'sheetname'"
                                  :disabled="isPrinting"
                                  class="btn btn-primary btn-sm float-right"
                                >
                                  <div
                                    @click.prevent="handleExportPrint('excel')"
                                  >
                                    <i class="fa fa-file-excel-o"></i>
                                    {{ isPrinting ? 'Preparing...' : 'Excel' }}
                                  </div>
                                </vue-excel-xlsx>
                              </li>
                                <li>
                                    <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row justify-content-center">
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Department</label>
                                                    <select v-model="departmentId" name="department_id" class="form-control" @change="mainComponent(departmentId)">
                                                        <option value selected>Select Department</option>
                                                        <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Main Component</label>
                                                    <select v-model="mainComponentId" name="main_component_id" class="form-control">
                                                        <option value selected>Select Main Component</option>
                                                        <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{ mainComponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6 ">
                                                <div class="form-group">
                                                    <label for="">Search </label>
                                                    <input type="text" v-model="searchInput" placeholder="Enter component name or code" name="searchInput" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-2 mt-2">
                                                <div class="form-group">
                                                    <label for=""></label>
                                                    <button class=" mt-3 btn-info btn btn-sm" @click="getData()">Search</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <label>Showing:</label>
                                            <select class="form-select mx-2" style="width:120px" v-model="offset" @change="onPerPageChange">
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <label>entries</label>
                                        </div>

                                        <div class="card-box table-responsive">
                                            <p class="text-muted font-13 m-b-30"></p>
                                            <table :class="getTableClasses" style="width:100%">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Image</th>
                                                    <th>Component Name</th>
                                                    <th>Main Component Name</th>
                                                    <th>Department Name</th>
                                                    <th>Code</th>
                                                    <th>Critical Equipment</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(component , index) in components?.data" :key="component.id">
                                                    <td> {{ (components?.current_page - 1) * components?.per_page + index + 1 }}</td>
                                                    <td>
                                                        <a style="text-decoration: underline;color: #0a6aa1" target="_blank" v-if="component && component?.image != null" :href="component && component?.image ">View</a>
                                                    </td>
                                                    <td>{{component?.name}}</td>
                                                    <td>{{isEmpty(component.maincomponent) ? component?.maincomponent.name : ''}}</td>
                                                    <td>{{component?.department?.name}}</td>
                                                    <td>{{component.code}}</td>
                                                    <td>
                                                        <span class="badge badge-success" v-if="component?.critical_equipment == 1">Yes</span>
                                                        <span v-else class="badge badge-danger">No</span>
                                                    </td>
                                                    <td>{{component?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
                                                    <td>
                                                        <button type="button" @click="show(component)" class="btn btn-info btn-sm"><i class="fa fa-eye"></i></button>
                                                        <button v-if="isPermissionExist(PERMISSIONS.COMPONENT_EDIT)" type="button" @click="edit(component)" class="btn btn-primary btn-sm"><i class="fa fa-edit"></i></button>
                                                        <button v-if="isPermissionExist(PERMISSIONS.COMPONENT_DELETE) && false" type="button" @click="destroy(component)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>
                                                        <button v-if="isPermissionExist(PERMISSIONS.COMPONENT_CREATE)" title="Copy Component" type="button" @click="copyComponent(component)" class="btn btn-success btn-sm"><i class="fa fa-clone" aria-hidden="true"></i></button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <Pagination :pagination="components" :getData="getData"/>

                                            <div id="printArea" style="display: none">
                                                <div style="text-align: center;line-height: 20px;">
                                                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                    <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                                                    <div style="line-height: 10px;" class="font-weight-bold">Component List</div>
                                                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                    <table :class="getTableClasses" style="width:100%">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Image</th>
                                                            <th>Component Name</th>
                                                            <th>Main Component Name</th>
                                                            <th>Department Name</th>
                                                            <th>Code</th>
                                                            <th>Critical Equipment</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(component , index) in printItems" :key="component.id">
                                                            <td> {{ index + 1 }}</td>
                                                            <td>
                                                                <a style="text-decoration: underline;color: #0a6aa1" target="_blank" v-if="component && component?.image != null" :href="component && component?.image ">View</a>
                                                            </td>
                                                            <td>{{component?.name}}</td>
                                                            <td>{{isEmpty(component.maincomponent) ? component?.maincomponent.name : ''}}</td>
                                                            <td>{{component?.department?.name}}</td>
                                                            <td>{{component.code}}</td>
                                                            <td>
                                                                <span v-if="component?.critical_equipment == 1">Yes</span>
                                                                <span v-else>No</span>
                                                            </td>
                                                            <td>{{component?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="customerModalLongTitle">{{ editMode ? 'Edit' : 'Add ' }} Component</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
                            <div class="modal-body">
                                <alert-error :form="form"></alert-error>
                                <div class="row">
                                    <div class="col-md-4 col-sm-4 col-4">

                                        <div class="form-group">
                                            <label>Department Name</label>
                                            <select v-model="form.department_id" name="department_id" class="form-control" :class="{ 'is-invalid': form.errors.has('department_id') }" @change="mainComponent(form.department_id)">
                                                <option value="" selected>Select department</option>
                                                <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{sdepartment.name}}</option>
                                            </select>
                                            <has-error :form="form" field="department_id"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Main Component </label>
                                            <select v-model="form.main_component_id" name="main_component_id" class="form-control" :class="{ 'is-invalid': form.errors.has('main_component_id') }">
                                                <option value="" selected>Select component</option>
                                                <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{mainComponent.name}}</option>
                                            </select>
                                            <has-error :form="form" field="main_component_id"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label> Name</label>
                                            <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                            <has-error :form="form" field="name"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label> Code</label>
                                            <input autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                                            <has-error :form="form" field="code"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Maker Ref Info</label>
                                            <input autocomplete="off" v-model="form.maker_ref_info" type="text" name="maker_ref_info" class="form-control" :class="{ 'is-invalid': form.errors.has('maker_ref_info') }">
                                            <has-error :form="form" field="maker_ref_info"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Budget Head</label>
                                            <select v-model="form.budget_head_id" name="budget_head_id" class="form-control" :class="{ 'is-invalid': form.errors.has('budget_head_id') }">
                                                <option v-for="budgetHead in budgetHeads" :key="budgetHead.id" :value="budgetHead.id">{{budgetHead.name}}</option>
                                            </select>
                                            <has-error :form="form" field="budget_head_id"></has-error>
                                        </div>

                                        <div class="form-group custom-control custom-checkbox">
                                            <input id="criticalEquipments" autocomplete="off" v-model="form.critical_equipment" type="checkbox" name="code" class="custom-control-input mx-2" :class="{ 'is-invalid': form.errors.has('critical_equipment') }">
                                            <has-error :form="form" field="critical_equipment"></has-error>
                                            <label class="custom-control-label" for="criticalEquipments">Critical Equipment </label>
                                        </div>

                                    </div>

                                    <div class="col-md-4 col-sm-4 col-4">
                                        <div class="form-group">
                                            <label>Manual </label>
                                            <input autocomplete="off" v-model="form.manual_id" type="text" name="maker" class="form-control" :class="{ 'is-invalid': form.errors.has('manual_id') }">
                                            <has-error :form="form" field="manual_id"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label> Maker</label>
                                            <input autocomplete="off" v-model="form.maker" type="text" name="maker" class="form-control" :class="{ 'is-invalid': form.errors.has('maker') }">
                                            <has-error :form="form" field="maker"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Serial No</label>
                                            <input autocomplete="off" v-model="form.serial_no" type="text" name="serial_no" class="form-control" :class="{ 'is-invalid': form.errors.has('serial_no') }">
                                            <has-error :form="form" field="serial_no"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Bearing No</label>
                                            <input autocomplete="off" v-model="form.bearing_no" type="text" name="bearing_no" class="form-control" :class="{ 'is-invalid': form.errors.has('bearing_no') }">
                                            <has-error :form="form" field="bearing_no"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Model</label>
                                            <input autocomplete="off" v-model="form.model" type="text" name="model" class="form-control" :class="{ 'is-invalid': form.errors.has('model') }">
                                            <has-error :form="form" field="model"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Rating</label>
                                            <input autocomplete="off" v-model="form.rating" type="text" name="rating" class="form-control" :class="{ 'is-invalid': form.errors.has('rating') }">
                                            <has-error :form="form" field="rating"></has-error>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-4">

                                        <div class="form-group">
                                            <label>Misc Info</label>
                                            <input autocomplete="off" v-model="form.misc_info" type="text" name="misc_info" class="form-control" :class="{ 'is-invalid': form.errors.has('misc_info') }">
                                            <has-error :form="form" field="misc_info"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Image </label>
                                            <input type="file" class="form-control" @change="covertImage" accept="image/*">
                                        </div>

                                        <div class="form-group">
                                            <label>Status</label>
                                            <select v-model="form.status" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                                <option value="Activate">Activate</option>
                                                <option value="Deactivate">Deactivate</option>
                                            </select>
                                            <has-error :form="form" field="status"></has-error>
                                        </div>

                                        <div v-if="form.matrix" id="accordion" class="accordion">
                                            <div class="card mb-0">
                                                <div class="card-header mb-0 collapsed pointer btn-outline-secondary border" data-toggle="collapse" href="#collapseOne">
                                                    <a class="card-title">SCE MATRIX</a>
                                                </div>
                                                <div id="collapseOne" class="card-body collapse" data-parent="#accordion">
                                                    <div class="list-group">
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="cargoTanks" v-model="form.matrix.cargo_tanks" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="cargoTanks">Loss of Containment at Cargo Tanks</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="riserTurret" v-model="form.matrix.riser_turret" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="riserTurret">Loss of Containment at Riser/Turret</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="offloadingHose" v-model="form.matrix.offloading_hose" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="offloadingHose">Loss of Containment at Offloading Hose</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="stationKeeping" v-model="form.matrix.station_keeping" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="stationKeeping">Loss of Station Keeping</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="structuralFailure" v-model="form.matrix.structural_failure" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="structuralFailure">Structural Failure</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="boatCollision" v-model="form.matrix.boat_collision" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="boatCollision">Boat Collision with FSO</label>
                                                            </div>
                                                        </li>
                                                        <li class="list-group-item">
                                                            <div class="custom-control custom-checkbox">
                                                                <input id="transferAccident" v-model="form.matrix.transfer_accident" type="checkbox" name="code" class="custom-control-input">
                                                                <label class="custom-control-label" for="transferAccident">Personnel Transfer Accident(Visitors)</label>
                                                            </div>
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="copyModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="customerModalLongTitle">Copy Component </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="store()" @keydown="form.onKeydown($event)">
                            <div class="modal-body">
                                <alert-error :form="form"></alert-error>
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 col-6">

                                        <div class="form-group">
                                            <label> Name</label>
                                            <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                            <has-error :form="form" field="name"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label> Code</label>
                                            <input autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                                            <has-error :form="form" field="code"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <input id="criticalEquipment" autocomplete="off" v-model="form.critical_equipment" type="checkbox" name="code" class="mx-2" :class="{ 'is-invalid': form.errors.has('critical_equipment') }">
                                            <has-error :form="form" field="critical_equipment"></has-error>
                                            <label>Critical Equipment </label>
                                        </div>

                                        <div class="form-group">
                                            <label>Maker Ref Info</label>
                                            <input autocomplete="off" v-model="form.maker_ref_info" type="text" name="maker_ref_info" class="form-control"
                                                   :class="{ 'is-invalid': form.errors.has('maker_ref_info') }">
                                            <has-error :form="form" field="maker_ref_info"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Budget Head</label>
                                            <select v-model="form.budget_head_id" name="budget_head_id" class="form-control" :class="{ 'is-invalid': form.errors.has('budget_head_id') }">
                                                <option v-for="budgetHead in budgetHeads" :key="budgetHead.id" :value="budgetHead.id">{{budgetHead.name}}</option>
                                            </select>
                                            <has-error :form="form" field="budget_head_id"></has-error>
                                        </div>
                                        <div class="form-group">
                                            <label>Bearing No</label>
                                            <input autocomplete="off" v-model="form.bearing_no" type="text" name="bearing_no" class="form-control" :class="{ 'is-invalid': form.errors.has('bearing_no') }">
                                            <has-error :form="form" field="bearing_no"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Model</label>
                                            <input autocomplete="off" v-model="form.model" type="text" name="model" class="form-control" :class="{ 'is-invalid': form.errors.has('model') }">
                                            <has-error :form="form" field="model"></has-error>
                                        </div>

                                    </div>

                                    <div class="col-md-6 col-sm-6 col-6">
                                        <div class="form-group">
                                            <label>Manual </label>
                                            <input autocomplete="off" v-model="form.manual_id" type="text" name="maker" class="form-control" :class="{ 'is-invalid': form.errors.has('manual_id') }">
                                            <has-error :form="form" field="manual_id"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label> Maker</label>
                                            <input autocomplete="off" v-model="form.maker" type="text" name="maker" class="form-control" :class="{ 'is-invalid': form.errors.has('maker') }">
                                            <has-error :form="form" field="maker"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Serial No</label>
                                            <input autocomplete="off" v-model="form.serial_no" type="text" name="serial_no" class="form-control" :class="{ 'is-invalid': form.errors.has('serial_no') }">
                                            <has-error :form="form" field="serial_no"></has-error>
                                        </div>


                                        <div class="form-group">
                                            <label>Rating</label>
                                            <input autocomplete="off" v-model="form.rating" type="text" name="rating" class="form-control" :class="{ 'is-invalid': form.errors.has('rating') }">
                                            <has-error :form="form" field="rating"></has-error>
                                        </div>
                                        <div class="form-group">
                                            <label>Misc Info</label>
                                            <input autocomplete="off" v-model="form.misc_info" type="text" name="misc_info" class="form-control" :class="{ 'is-invalid': form.errors.has('misc_info') }">
                                            <has-error :form="form" field="misc_info"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <label>Image </label>
                                            <input type="file" class="form-control" @change="covertImage" accept="image/*">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="showModal" tabindex="-1" role="dialog" aria-labelledby="showModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="showModalLabel">{{ form.name }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered table-hover">
                                    <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <td>{{ form.name }}</td>
                                    </tr>
                                    <tr>
                                        <th>Budget Code</th>
                                        <td>{{ form.code}}</td>
                                    </tr>
                                    <tr>
                                        <th>Manual Id</th>
                                        <td>{{ form.manual_id }}</td>
                                    </tr>
                                    <tr>
                                        <th>Code</th>
                                        <td>{{ form.code }}</td>
                                    </tr>
                                    <tr>
                                        <th>Maker</th>
                                        <td>{{ form.maker }}</td>
                                    </tr>
                                    <tr>
                                        <th>Model</th>
                                        <td>{{ form.model }}</td>
                                    </tr>
                                    <tr>
                                        <th>Maker Ref Info</th>
                                        <td>{{ form.maker_ref_info }}</td>
                                    </tr>
                                    <template v-if="form.matrix">
                                        <tr>
                                            <th class="text-center" colspan="2">SCE Matrix</th>
                                        </tr>
                                        <tr>
                                            <th>Loss of Containment at Cargo Tanks</th>
                                            <td><i v-if="form?.matrix?.cargo_tanks === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Loss of Containment at Riser/Turret</th>
                                            <td><i v-if="form?.matrix?.riser_turret === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Loss of Containment at Offloading Hose</th>
                                            <td><i v-if="form?.matrix?.offloading_hose === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Loss of Station Keeping</th>
                                            <td><i v-if="form?.matrix?.station_keeping === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Structural Failure</th>
                                            <td><i v-if="form?.matrix?.structural_failure === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Boat Collision with FSO</th>
                                            <td><i v-if="form?.matrix?.boat_collision === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th>Personnel Transfer Accident(Visitors)</th>
                                            <td><i v-if="form?.matrix?.transfer_accident === '1'" class="fa fa-check"></i></td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row">
                                <div class="col-md-6"></div>
                                <div class="col-md-6"></div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import auth from '../../auth'
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";
    import PermissionsMixin from "@/mixin/permissionsMixin";

    export default {
        components: {Pagination, PulseLoader},
        mixins: [goBackButtonMixin, PermissionsMixin],
        name: 'JobComponent',
        data() {
            return {
                loading: false,
                editMode: false,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                printItems: [],
                query: '',
                queryFiled: 'name',
                departments: [],
                departmentId: '',
                mainComponentId: '',
                mainComponents: [],
                searchInput: '',
                offset: 20,
                selectedMainComponent: null,
                components: [],
                budgetHeads: [],
                excelHeader: [],
                excelData: [],
                form: new Form({
                    id: '',
                    name: '',
                    main_component_id: '',
                    department_id: '',
                    budget_head_id: '',
                    manual_id: '',
                    code: '',
                    maker: '',
                    model: '',
                    maker_ref_info: '',
                    serial_no: '',
                    bearing_no: '',
                    rating: '',
                    misc_info: '',
                    image: '',
                    critical_equipment: '',
                    vessel_id: auth.getVesselId(),
                    status: 'Activate',
                    matrix: {
                        cargo_tanks: '',
                        riser_turret: '',
                        offloading_hose: '',
                        station_keeping: '',
                        structural_failure: '',
                        boat_collision: '',
                        transfer_accident: ''
                    }
                }),
                showInfo: {
                    budget_heade_name: '',
                    manual_name: '',
                },
                pagination: {
                    current_page: 1
                },
                vessel_id: auth.getVesselId(),
            }
        },
        mounted() {
            this.departmentList();
            this.budgetHeadsList();
            this.getData();
        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                };
            }
        },
        watch: {
            'form.main_component_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form.code = this.updateCode(newVal, this.mainComponents);
                }
            },
        },
        methods: {
            updateCode(parent_id, components) {
                const selectedComponent = components.find(component => component.id === parent_id);
                if (selectedComponent && selectedComponent.code) {
                    return selectedComponent.code + '-';
                }
                return '';
            },
            onPerPageChange() {
                this.getData(1);
            },
            getData(page = 1) {
                this.loading = true;
                var params = {
                    page: page,
                    is_all: 0,
                    department_id: this.departmentId,
                    main_component_id: this.mainComponentId,
                    search: this.searchInput,
                    offset: this.offset,
                };
                this.$http.get('/api/filter/component/' + this.vessel_id, {params}).then(response => {
                    this.loading = false;
                    this.components = response.data.success
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Component Name': `${item?.name || ''}`,
                'Main Component': `${item?.maincomponent.name || ''}`,
                'Department Name': `${item?.department?.name || ''}`,
                'Code': `${item?.code || ''}`,
                'Critical Equipment': `${item?.critical_equipment ==  1 ? 'Yes' : 'No'}`,
                'Status': `${item?.status == 'Activate' ? 'Active' : 'Inactive'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
                department_id: this.departmentId,
                main_component_id: this.mainComponentId,
                search: this.searchInput,
                offset: this.offset,
              };

              const res = await this.$http.get('/api/filter/component/' + this.vessel_id, {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Component List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            create() {
                this.editMode = false;
                this.form.reset();
                this.form.clear();
                $('#roleModal').modal('show')
            },
            covertImage(event) {
                let file = event.target.files[0];
                this.form.image = file;
            },
            store() {
                this.form.busy = true;
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form.post('/api/component').then(response => {
                    this.getData(Number(this.components?.current_page));
                    $('#roleModal').modal('hide');
                    $('#copyModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success(' Component Created Successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        this.$snotify.error('Sorry Component can not create successfully', 'Error')
                    }

                })
            },
            async edit(component) {
                this.editMode = true;
                this.form.reset();
                this.form.clear();
                await this.mainComponent(component.department_id);
                this.form.fill(component);
                setTimeout(() => {
                    this.form.code = component.code
                }, 1000);

                if (component.matrix && Object.keys(component.matrix).length) {
                    this.form.matrix = {
                        cargo_tanks: (component.matrix?.cargo_tanks === "1") ? 1 : 0,
                        riser_turret: (component.matrix?.riser_turret === "1") ? 1 : 0,
                        offloading_hose: (component.matrix?.offloading_hose === "1") ? 1 : 0,
                        station_keeping: (component.matrix?.station_keeping === "1") ? 1 : 0,
                        structural_failure: (component.matrix?.structural_failure === "1") ? 1 : 0,
                        boat_collision: (component.matrix?.boat_collision === "1") ? 1 : 0,
                        transfer_accident: (component.matrix?.transfer_accident === "1") ? 1 : 0,
                    };
                }else{
                  this.form.matrix = {
                    cargo_tanks: 0,
                    riser_turret: 0,
                    offloading_hose:0,
                    station_keeping: 0,
                    structural_failure:0,
                    boat_collision:0,
                    transfer_accident:0,
                  };
                }

                $('#roleModal').modal('show');
            },
            copyComponent(component) {
                this.form.reset();
                this.form.clear();
                this.form.fill(component);
                $('#copyModal').modal('show');
            },
            update() {
                this.form.busy = true;
                this.form.critical_equipment = this.form.critical_equipment == true ? 1 : 0;
                this.form._method = 'put';
                this.form.post('/api/component/' + this.form.id).then(response => {
                    this.getData(Number(this.components?.current_page));
                    $('#roleModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success(' component successfully Update')
                    } else {
                        this.$snotify.error('Something went wrong try again later.', 'Error')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            destroy(Component) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete('/api/component/' + Component.id).then(response => {
                        this.getData(Number(this.components?.current_page));
                        this.$snotify.success(' Component Successfully Deleted')
                    }).catch(error => {
                        let response = error.response;
                        if (response.status === 403) {
                            this.$snotify.warning(response?.data?.error)
                        } else {
                            var err = error.response.data.error;
                            this.$snotify.error(err)
                        }

                    })
                }).catch(function (e) {
                    console.log(e)
                })

            },
            departmentList() {
                var params = {
                    is_all: 1,
                };
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            mainComponent(department_id) {
                this.mainComponentId = '';
                var params = {
                    is_all: 1,
                };
                if (department_id == '') {
                    this.mainComponents = [];
                    return Promise.resolve();
                } else {
                    return this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + department_id, {params})
                        .then(response => {
                            this.mainComponents = response.data.success;
                        })
                        .catch(e => {
                            console.log(e);
                            return Promise.reject(e);
                        });
                }
            },
            budgetHeadsList() {
                this.$http.get('/api/filter/budget-head/' + this.vessel_id).then(response => {
                    this.budgetHeads = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            show(component) {
                this.form.reset();
                this.form.fill(component);
                $('#showModal').modal('show');
            },
            isEmpty(obj) {
                if (obj != null) {
                    return true
                } else {
                    return false
                }
            }

        }
    }
</script>

<style scoped>
    .des {
        height: 36% !important;
    }

    .custom-control-label::before {
        top: 2px;
    }

    .accordion .card-header:after {
        font-family: 'FontAwesome';
        content: "\f068";
        float: right;
    }

    .accordion .card-header.collapsed:after {
        /* symbol for "collapsed" panels */
        content: "\f067";
    }
</style>
